import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  align: "center",
  class: "login-box"
};
import store from "../store";
import { reactive, ref } from "vue";
import { getpviptype } from "@/request/vipmenu";
import { ElMessage } from "element-plus";
import { weblogin } from "../request/userlist";
export default /*@__PURE__*/_defineComponent({
  __name: 'weblogin',
  emits: ["clickChild"],
  setup(__props, {
    emit: __emit
  }) {
    const ruleFormRef = ref();
    const ruleForm = reactive({
      userid: "",
      userpw: ""
    });
    const rules = {
      userid: [{
        required: true,
        message: "Please input username",
        trigger: "blur"
      }, {
        min: 1,
        max: 10,
        message: "Length should be 3 to 10",
        trigger: "blur"
      }],
      userpw: [{
        required: true,
        message: "Please input password",
        trigger: "blur"
      }, {
        min: 1,
        max: 10,
        message: "Length should be 3 to 10",
        trigger: "blur"
      }]
    };
    const submitForm = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          localStorage.clear();
          weblogin(ruleForm).then(res => {
            console.log("jjjjjres.data");
            if (res.data.code == 401) ElMessage(res.data.msg);
            // 将token进行保存
            localStorage.setItem("token", res.data.data.token);
            store.commit("setName", res.data.data.username);
            store.commit("setjf", res.data.data.jf);
            if (res.data.data.hfaceurl == "" || res.data.data.hfaceurl == null) store.commit("sethfaceurl", "");else store.commit("sethfaceurl", store.state.imageurl + "/image/" + res.data.data.hfaceurl);
            store.commit("setowner", ruleForm.userid);
            store.commit("setusertype", "user");
            store.commit("setuuid", res.data.data.uuid);
            getpviptype(ruleForm.userid).then(res => {
              if (res.data.data.length > 0) {
                store.commit("setvip", true);
                /*
                store.commit("settype", res.data.data.type);
                var rangename = res.data.data.rangename.split(",");
                var rangeid = res.data.data.rangeid.split(",");
                var t = [];
                for (var i = 0; i < rangename.length; i++) {
                  t.push({
                    name: rangename[i],
                    fid: rangeid[i],
                  });
                }
                store.commit("setrangeList", t);
                */
              }
            });

            clickChild(1);
          }).catch(() => {
            ElMessage("用户名或密码错");
          });
        } else {
          ElMessage("用户名或密码不能空");
          return false;
        }
      });
    };
    const emit = __emit;
    const clickChild = type => {
      let param = {
        typeid: type
      };
      //传递给父组件
      emit("clickChild", param);
    };
    return (_ctx, _cache) => {
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[11] || (_cache[11] = _createElementVNode("h1", null, "登 录", -1)), _createVNode(_component_el_divider), _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        "status-icon": "",
        rules: rules,
        "label-width": "80px",
        class: "demo-ruleForm",
        style: {
          "max-width": "500px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "用户",
          prop: "userid"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: ruleForm.userid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ruleForm.userid = $event),
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "密码",
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: ruleForm.userpw,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ruleForm.userpw = $event),
            type: "userpw",
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = $event => submitForm(ruleFormRef.value))
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 登录 ", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            class: "register_btn",
            onClick: _cache[3] || (_cache[3] = $event => clickChild(0))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("退出", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "btn"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_checkbox, {
            class: "rememberMe"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("记住密码？", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "info",
            onClick: _cache[4] || (_cache[4] = $event => clickChild(2)),
            class: "register_btn"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("注册", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "info",
            onClick: _cache[5] || (_cache[5] = $event => clickChild(3)),
            class: "ps_btn"
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("找回密码", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});